'use client'

import React, { FC, ReactElement } from 'react'
import styles from './QrScanner.module.css'
import QRCodeIcon from '@/icons/qr-code'
import QrReader from 'react-qr-scanner'
import Modal from '@/components/modal-v2'
import useWindowSize from '@/utils/hooks/useWindowSize'
import XIcon from '@/icons/x-icon'
import classnames from 'classnames'
import Loading from '@/components/circle-loading'

const QrScanner: FC<{ onSuccess: (res: string) => void; onError: () => void }> = (
	props
): ReactElement => {
	const [open, setOpen] = React.useState(false)
	const [ready, setReady] = React.useState(false)
	const { isDesktop } = useWindowSize()
	// const isDesktop = true

	const style = {
		height: '100%',
		width: '100%',
		objectFit: 'fill',
		aspectRatio: 16 / 9,
		background: 'transparent'
	}

	const handleSuccess = (res: any) => {
		if (!res?.text) {
			return
		}

		setReady(false)
		setOpen(false)
		props.onSuccess(res.text.trim())
	}

	const handleError = () => {
		setReady(false)
		setOpen(false)
		props.onError()
	}

	const handleCancel = () => {
		setReady(false)
		setOpen(false)
	}

	return (
		<>
			<QRCodeIcon className={styles.icon} onClick={() => setOpen(true)} />
			<Modal open={open} onClose={() => {}} bodyClassName={styles.modal}>
				{ready ? (
					<>
						<XIcon className={styles.cancelIcon} onClick={handleCancel} />
						<div className={styles.scanCode}>
							<span className={classnames(styles.scanCodeAngle, styles.scanCodeAngleTop)}></span>
							<span className={classnames(styles.scanCodeAngle, styles.scanCodeAngleBottom)}></span>
						</div>
					</>
				) : (
					<div className={styles.loadingContainer}>
						<Loading className={styles.loading} />
					</div>
				)}
				<QrReader
					style={style}
					delay={0}
					onError={handleError}
					onScan={handleSuccess}
					onLoad={() => setReady(true)}
					constraints={
						isDesktop
							? undefined
							: {
									video: {
										facingMode: { exact: `environment` }
									}
							  }
					}
				/>
			</Modal>
		</>
	)
}

export default QrScanner
